import { getTemplate } from "../template-helper";
import { translateElement } from "../../util/locales";

const COMPONENT_NAME = "z-button-form" ;

const TEMPLATE_ID = "component-"+COMPONENT_NAME+"-template" ;
const TEMPLATE_URL = "/static/libs/components/"+COMPONENT_NAME+".html" ;

export default function register(){
    getTemplate(TEMPLATE_ID, TEMPLATE_URL).then((template)=>{
        
        class ButtonFormComponent extends HTMLElement {
            constructor() {
                super();
                if(!this.innerHTML.trim()){
                    this.initMarkup() ;
                }
            }

            initMarkup(){
                const clone = document.importNode(template.content, true);
                this.appendChild(clone);

                const btSave = this.querySelector("z-button-save") ;
                const btDelete = this.querySelector("z-button-delete") ;

                if(this.hasAttribute("z-field-id")){
                    if(btSave){
                        btSave.setAttribute("z-field-id", this.getAttribute("z-field-id")) ;
                    }
                    if(btDelete){
                        btDelete.setAttribute("z-field-id", this.getAttribute("z-field-id")) ;
                    }
                }
                translateElement(this) ;
            }

            attributeChangeCallback(name, oldValue, newValue){
                switch(name){
                    case 'z-field-id':
                        this.updateFieldId() ;
                        break;
                }
            }

            updateFieldId(container){
                if(!container){
                    container = this ;
                }
                const btSaves = container.querySelectorAll("z-button-save") ;
                const btDeletes = container.querySelectorAll("z-button-delete") ;

                for(let btSave of btSaves){
                    btSave.setAttribute("z-field-id", this.getAttribute("z-field-id")) ;
                }
                for(let btDelete of btDeletes){
                    btDelete.setAttribute("z-field-id", this.getAttribute("z-field-id")) ;
                }

                const templates = container.querySelectorAll("template") ;
                for(let template of templates){
                    this.updateFieldId(template.content) ;
                }
            }
        }
        customElements.define(COMPONENT_NAME, ButtonFormComponent);
    }).catch((err)=>{
        throw err ;
    }) ;
}
